export default {
  BAndRText: "Libri & Recensioni",
  Srchbook: "Cerca per libro",
  offlisugg: "Suggerimenti di Ofellio ",
  recentlyRated: "Valutati di recente",


  // ReviewPage
  rewbtn1: "Da leggere",
  rewbtn2: "Scrivi una recensione",
  rewbtn3: "Usare per Book Duo",
  rateBook: "Valuta questo libro",
  buyon: "Acquista su",
  Read: "Letto",
  reviewtext: "Recensione",
  ratingtext: "Il tuo voto",
  readon: "Letto su",
  book: "Libro",
  ebook: "E-book",
  audiobook: "Audiobook",
  revTitle: "Titolo",
  submitbtn: "Invia",


  // Book Duo Page
  yourbd: "Il tuo Book Duo",
  serchbook: "Cerca libro",
  DidText: "Non hai trovato il tuo libro? Inserisci i dettagli!",
  city: "Città",
  type: "Tipo",
  lookigfr: "Cerco",
  male: "Maschio",
  female: "Femmina",
  idk: "Indifferente",
  agerg: "Fascia di età",
  language: "Lingua ",
  detil: "Dettagli ",
  optnal: "Opzionale",
  lookiginsp: "Alcuni suggerimenti",
  suggbokduo: "Libri suggeriti per un Book Duo",
  seemoresugg: "Vedi altri suggerimenti",
  bokcvr: "Copertina ",
  title: "Titolo",
  writer: "Autore  ",
  genre: "Genere ",
  upload: "Carica ",
  add: "Aggiungi ",
  online: "Online"
  ,   onlink: "Aggiungi il link alla videochiamata (Teams, Zoom, Google Meet, ecc.)",
  noBookSelected: "Nessun libro selezionato",
  loading: "Caricamento...",
  noResultsFound: "Nessun risultato trovato",
  meetingLink: "Link della riunione",
  noLimit: "Senza limite",
  languageTooltip: "Questa è la lingua che i partecipanti parleranno durante il Book Duo.",
  languageTooltipBookClub: "Questa è la lingua che i partecipanti parleranno durante il Book Club.",
  updating: "Aggiornamento...",
  publishing: "Pubblicazione...",
  update: "Aggiorna",
  noBooksFound: "Nessun libro trovato sotto questo suggerimento per un 1:1.",
  wellDone: "Ben fatto!",
  bookDuoLive: "Il tuo Book Duo è ora attivo.",
  willInformInterest: "Ti informeremo quando qualcuno mostrerà interesse!",
  seeOn: "Vedi su",
  map: "Mappa",

  // Book Club Page
  when: "Quando",
  time: "Ora ",
  age: "Età",
  publsbtn: "Pubblica ",
  day: "Giorno",
  month: "Mese ",
  year: "Anno",
  hour: "Ora",
  min: "Min",
  max: "Max",
  selectTime: "Seleziona l'ora",
  selectLanguage: "Seleziona la lingua",
  selectType: "Seleziona il tipo",
  inPerson: "Di persona",
  attendees: "Partecipanti",
  eventDetails: "Dettagli dell'evento",

  // Silent Reading Page
  where: "Dove",
  venue: "Luogo",
  address: "Indirizzo",


  // BookAnd Review page Event
  welc: "Benvenuto",
  memb: "Membro",
  exploreText: "Esplora e partecipa agli eventi disponibili nella tua città o online e crea il tuo.",
  sbybooks: "Cerca per titoli",
  month: "Mese ",
  sortby: "Ordina per",
  cbduo: "Crea Book Duo",
  smoreevent: "Vedi altri eventi"
  , dowant: "Vuoi creare il tuo evento?",
  ledAmbsdr: "I Book Clubs e la Silent Reading sono condotti dagli Ambassadors.",
  bAnAmbsdor: "Diventa un Ambassador  ",
  leadText: "Guidarne uno oppure esplorare e partecipare",
  evtnear: " eventi disponibili vicino a te.",
  BookDuoFirstText: `Cerchi una connessione autentica? Un Book Duo è perfetto per te!`,
  BookDuoSecondText: `Scegli semplicemente un libro, seleziona il genere e la fascia d’età del partner con cui vuoi entrare in contatto, e sei pronto! Quando qualcuno mostrerà interesse, inizierai una chat e organizzerai i dettagli del tuo evento one-to-one`,

  BookClubFirstText: `Scopri i Book Club di persona nella tua zona o online, organizzati in ambienti accoglienti come caffè, bar o luoghi ospitali  , oppure tramite videoconferenza. `,
  BookClubSecondText: `Ogni Ofellio Book Club accoglie fino a 8 partecipanti, suddivisi per fascia d'età per offrire un'esperienza più confortevole e coinvolgente. La discussione sarà facilitata da un Ambassador Ofellio, garantendo un'atmosfera vivace e inclusiva`,

  BookSilentFirstText: `Tenuti in un ambiente rilassante e confortevole, i Silent Readings offrono una tranquilla fuga per un massimo di 10 lettori.`,
  BookSilentSecondText: `Guidata da un Ambassador Ofellio, ogni sessione ti invita a portare il tuo libro, leggere in silenzio e, se lo desideri, entrare in contatto con gli altri in un’atmosfera distesa.`,

  DuoBtnText: `Crea Book Duo`,
  ClubBtnText: `Crea Book Club`,
  SilentBtnText: `Crea Silent Reading`,
  bookDuoTitle: "Book Duo",
  bookClubTitle: "Book Club",
  bookSilentTitle: "Silent Reading",






  // BOOK_CLUB DUO SILENTREADING
  yownbook: "Il tuo libro",
  resetFilters: "Reimposta filtri",
  resetAll: "Reimposta tutto",
  applyFilters: "Applica filtri",
  filters: "Filtri",
  full: "COMPLETO",
  booksCover: "Copertina del libro",
  writerLabel: "Autore",
  genreLabel: "Genere",
  aboutTheBookLabel: "Informazioni sul libro",
  addButton: "Aggiungi",
  booked: "Prenotato",
  open: "Aperto",
  buyon: "Acquista su",
  gender: "Genere",
  locatedin: "Posizione",
  aboutbook: `Trama`,
  readmore: `Leggi di più `,
  readless: `Leggi di meno `
  , details: "Dettagli",
  totalspot: "Posti totali",
  spotleft: "Posti disponibili",
  join: "Partecipa",
  share: "Condividi",
  cregistration: "Completa la registrazione",
  registrationmsg: "Il tuo indirizzo e-mail sarà condiviso con l'Ambassador",
  welldone: "Ben fatto!",
  attending: "Stai partecipando a ",
  attendmsg: "Ora puoi vedere questo evento nel tuo dashboard di Ofellio e chattare con il tuo Ambassador"
  , thankyou: "Grazie!",
  thankmsg: "L'organizzatore ora è a conoscenza del tuo interesse e potrebbe inviarti un messaggio per organizzare i dettagli di questo Book Duo"
  ,



  // CHAT PAGE
  msgtext: "Messaggi ",
  vprofile: "Vedi profilo",
  mute: "Silenzia",
  block: "Blocca",
  unblock: "Sbloccare"

  , report: "Segnala",

  // Setting Page
  pprofile: "Profilo personale",
  accnotifi: "Notifiche",
  uploadp: "Carica foto",
  name: "Nome",
  surname: "Cognome",
  dob: "Data di nascita",
  aboutme: "Su di me",
  country: "Paese",
  favgenre: "Generi preferiti",
  asmedia: "Aggiungi i tuoi account social",
  savechgbtn: "Salva modifiche",

  cypass: "Cambia la tua password",
  cypasstext: "Quando cambi la tua password, sarai automaticamente disconnesso dalle altre sessioni",
  cpass: "Cambia password",
  cyemail: "Cambia e-mail",
  cyemailtext: "Quando cambi password, sarai automaticamente disconnesso da altre sessioni",
  cemail: "Cambia e-mail",
  notifi: "Notifica ",
  emailmeab: "Avvisami su",
  lastesttext: "Libri recenti di tendenza",
  upcomtext: "Nuovi libri del prossimo mese",
  baevent: "Libri, autori ed eventi che mi piacerebbero ",
  newoff: "Nuove funzionalità di Ofellio",


  curnpass: "Password attuale",
  newpass: "Nuova password",
  cnewpass: "Conferma nuova password",
  curnemail: "Email attuale",
  newemail: "Nuova email",
  cnewemail: "Conferma nuova email",
  delyacc: "Elimina account ",
  sorrytext: "Ci dispiace molto che tu voglia lasciarci!",
  suretext: "Sei sicuro di volerlo fare? ",
  decitext: "Se decidi di usare di nuovo Ofellio, dovrai creare un nuovo account.",
  pass: "Password",

  // meun
  jan: "Gennaio",
  feb: "Febbraio",
  mar: "Marzo",
  apr: "Aprile",
  may: "Maggio",
  jun: "Giugno",
  jul: "Luglio",
  aug: "Agosto",
  sep: "Settembre",
  oct: "Ottobre",
  nov: "Novembre",
  dec: "Dicembre",
  // Month abbreviations
  monthAbbrJan: "Gen",
  monthAbbrFeb: "Feb",
  monthAbbrMar: "Mar",
  monthAbbrApr: "Apr",
  monthAbbrMay: "Mag",
  monthAbbrJun: "Giu",
  monthAbbrJul: "Lug",
  monthAbbrAug: "Ago",
  monthAbbrSep: "Set",
  monthAbbrOct: "Ott",
  monthAbbrNov: "Nov",
  monthAbbrDec: "Dic",
  cri: "Giallo ",
  fic: "Narrativa  ",
  grpnvl: "Fumetti e Mang",
  yng: "Giovani Adulti e LGBTQ+",
  nonfic: "Saggistica ",
  scifan: "Fantascienza e Fantasy ",
  others: "Altri",
  morerec: "Più recenti",
  lessrec: "Meno recenti ",
  // HeaderProfil
  setg: "Impostazioni ",
  logout: "Esci",

  // dashbords pages
  editprf: "Modifica profilo",
  cbduo: "Crea Book Duo",
  joining: "Partecipo",
  bandrew: "Libri & Recensioni",
  upcomclub: "Prossimi Book Clubs",
  upcomduo: "Prossimi Book Duo",
  upcomsil: "Prossimi Silent Readings",
  allpst: "Eventi passati",
  edit: "Modifica",
  going: "Vado",
  ngoing: "Non vado",
  cancel: "Annulla",

  level: "Livello",
  cbclub: "Crea Book Club",
  cbsil: "Crea Silent Reading  ",
  loyprog: "Programma fedeltà",
  mang: "Gestisci",
  attlist: "Lista partecipanti",
  event: "Modifica evento",

  chatgroup: "Chatta con il gruppo",
  chatambas: "Chatta con Ambassador",

  bookshelv: "Librerie di",
  reviews: "Recensioni",

  // Leading Page
  ambassador: "Ambassador",
  member: "Membro",
  level1: "Livello 1",
  level2: "Livello 2",
  level3: "Livello 3",
  level4: "Livello 4",
  toLevel: "a",
  highestLevel: "🎉 Hai raggiunto il livello più alto!",
  editProfile: "Modifica profilo",
  createBookClub: "Crea Book Club",
  createSilentReading: "Crea Silent Reading",
  createBookDuo: "Crea Book Duo",
  createEvent: "+ Crea evento",
  attendeesList: "Lista partecipanti",
  wantToRead: "Da leggere",
  remove: "Rimuovi",
  tbd: "Da definire",
  full: "COMPLETO",
  yourOwnBook: "Il tuo libro",
  ageLabel: "Età:",
  manage: "Gestisci",
  cancelRSVP: "Annulla RSVP",
  imLeading: "Sto guidando",
  imJoining: "Sto partecipando",
  booksAndReviews: "Libri & Recensioni",
  loyaltyProgram: "Programma fedeltà",
  upcomingBookClubs: "Prossimi Book Clubs",
  upcomingSilentReadings: "Prossimi Silent Readings",
  upcomingBookDuos: "Prossimi Book Duos",
  noEventsToShow: "Nessun evento da mostrare.",
  wantToReadLower: "Da leggere",
  readLower: "Letto",
  reviewsLower: "Recensioni",
  noRatedBooks: "Non hai ancora valutato nessun libro.",
  giftsDiscounts: "Regali e sconti sulla lettura",
  loyaltyDescription: "Più leggi, più vinci! Goditi sconti e vantaggi mentre sali di livello.",
  starterReader: "Lettore principiante",
  starterReaderDesc: "Inizia il tuo viaggio come Ambassador Ofellio e inizia a guidare le tue prime esperienze di lettura.",
  starterReaderReward: "Riconoscimento anticipato e accesso ai futuri vantaggi degli Ambassadors.",
  communityBuilder: "Costruttore di comunità",
  communityBuilderDesc: "Continua a connettere i lettori e a creare eventi di libri coinvolgenti all'interno della tua comunità.",
  communityBuilderReward: "Accesso prioritario a nuove funzionalità e aggiornamenti esclusivi.",
  proHost: "Host professionale",
  proHostDesc: "Stai dando forma a momenti di lettura significativi e ispirando gli altri attraverso i tuoi eventi.",
  proHostReward: "Inviti alle prossime iniziative Ofellio e sorprese speciali.",
  legend: "Leggenda",
  legendDesc: "Continua a ispirare i lettori in tutto il mondo: la tua leadership modella la comunità Ofellio.",
  legendReward: "Sblocca riconoscimenti esclusivi e vantaggi in evoluzione.",
  attendees: "Partecipanti",
  noAttendeesYet: "Nessun partecipante ancora.",
  chatWithGroup: "Chatta con il gruppo",
  cancelEvent: "Annulla evento",
  cancelRSVPConfirm: "Sei sicuro di voler annullare il tuo RSVP?",
  cancelEventConfirm: "Sei sicuro di voler annullare questo evento?",
  cancelRSVPEmail: "Un'email di cancellazione sarà inviata all'Ambassador.",
  cancelEventEmail: "Un'email di cancellazione sarà inviata ai partecipanti attuali.",

  // How It Works Section
  howOfellioWorks: "Come funziona Ofellio",
  howItWorksDesc: "Scopri nuovi modi per connetterti attraverso i libri — che si tratti di incontri one-to-one, in gruppo o in pacifiche sessioni di lettura silenziosa.",
  bookDuoTitle: "Book Duo",
  bookDuoDesc: "Cerchi una connessione personale? Scegli un libro, seleziona l'età e il genere del partner preferito e inizia un viaggio letterario one-to-one.",
  bookClubTitle: "Book Club",
  bookClubDesc: "Unisciti a Book Club accoglienti in presenza o online ospitati in ambienti accoglienti. Ogni gruppo è facilitato da un Ambassador per garantire un'esperienza vivace e inclusiva.",
  silentReadingTitle: "Silent Reading",
  silentReadingDesc: "Goditi pacifiche sessioni di lettura silenziosa. Porta il tuo libro, rilassati e condividi la gioia tranquilla della lettura insieme.",
  exploreThe: "Esplora gli",
  existingEvents: "eventi esistenti",
  or: "o",
  createYourOwn: "crea il tuo",
  joinOfellio: "Unisciti a Ofellio",
  signUp: "Registrati",
  chooseYourCountry: "Scegli il tuo paese",
  joined: "partecipato",
  joinedCapitalized: "Partecipato",
  shareThisEvent: "Condividi questo evento",
  linkVisibleAttendees: "Link visibile solo ai partecipanti",
  recentReviews: "Recensioni recenti",
  noReviewsAvailable: "Nessuna recensione disponibile",
  writeAReview: "Scrivi una recensione",
  yourRating: "La tua valutazione",
  update: "Aggiorna",
  aboutTheBook: "Informazioni sul libro",
  makeAChoiceForThisBook: "Fai una scelta per questo libro",
  howDidYouReadIt: "Come l'hai letto?",
  noRating: "Nessuna valutazione",
  reviewPublished: "Recensione pubblicata",
  useForBookDuo: "Usa per Book Duo",
  yourReview: "La tua recensione",
  addAShortTitle: "Aggiungi un titolo breve",
  shareYourThoughts: "Condividi i tuoi pensieri su questo libro...",
  send: "Invia",
  bookclubLive: "Complimenti! Il tuo Bookclub è online e le persone possono unirsi.",
  silentReadingLive: "Complimenti! La tua Lettura Silenziosa è online e le persone possono unirsi.",
  dashboard: "Dashboard",

  // Day abbreviations
  dayMon: "Lun",
  dayTue: "Mar",
  dayWed: "Mer",
  dayThu: "Gio",
  dayFri: "Ven",
  daySat: "Sab",
  daySun: "Dom",
  
  // Additional translations
  ambassadorLabel: "Ambassador:",
  createdBy: "Creato da:",
  youAreAttendingThis: "Stai partecipando a questo",
  youCanNowSeeThisEvent: "Ora puoi vedere questo evento nella tua dashboard di Ofellio e chattare",
  withYourAmbassador: "con il tuo Ambassador",
  chatWithAmbassador: "Chatta con Ambassador",
  yourRequestHasBeenSent: "La tua richiesta è stata inviata all'ambassador",
  sentYouAMessage: "ti ha inviato un messaggio!",
  justJoinedYour: "si è unito al tuo",
  bookClubsAndSilentReadings: "I Book Clubs e Silent Readings sono condotti dagli Ambassadors.",
  becomeAnAmbassador: "Diventa un Ambassador",
  toLeadOneOrExplore: "per guidarne uno o esplorare e partecipare a",
  eventsAvailable: "eventi disponibili.",
};
